<template>
  <div class="addEditDialog">
    <el-dialog :title="title" :visible.sync="$parent.dialogVisible" width="40%">
      <div class="formContent">
        <div class="userForm">
          <el-form
            label-width="80px"
            :model="formInline"
            ref="ruleForm"
            class="demo-form-inline"
            :rules="rules"
          >
            <el-form-item prop="titleTxt" :label="page">
              <el-input v-model="formInline.titleTxt"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="upLoadWrap">
          <el-upload
            class="upload-demo"
            drag
            action="#"
            :http-request="httpRequest"
            multiple
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :limit="1"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBtn">取 消</el-button>
        <el-button
          @click="submitForm('ruleForm')"
          type="primary"
          :loading="$store.state.user.loadingState"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import axios from "axios";
export default {
  props: ["title", "page"],
  data() {
    return {
      formInline: {
        titleTxt: "",
      },
      rules: {
        titleTxt: [
          { required: true, message: "标题不能为空" },
          { whitespace: true, message: "标题不能为空" },
        ],
      },
      param: null,
      fileList: [],
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.param) {
            this.$store.commit("SET_LOADING", true);
            let httpUrl = window.jujiParams.baseURL;
            let tokenString = window.sessionStorage.getItem("token");
            if (this.title != "编辑") {
              axios
                .post(
                  httpUrl +
                    `/api/juji/project/rules/add?title=${this.formInline.titleTxt}&category=${this.page}&projectIdStr=${JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0].projectId}`,
                  this.param,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                      "X-Authorization": `Bearer ${tokenString}`,
                    },
                  }
                )
                .then((res) => {
                  if (res && res.status == 200) {
                    res.data.status == "EXISTED"
                      ? this.$message.success("添加成功,文件已存在!")
                      : this.$message.success("添加成功!");
                    this.$parent.dialogVisible = false;
                    setTimeout(() => {
                      this.$parent.getList();
                      this.$store.commit("SET_LOADING", false);
                    }, 1000);
                  }
                });
            } else {
              axios
                .post(
                  httpUrl +
                    `/api/juji/project/rules/modify?projectIdStr=${JSON.parse(window.sessionStorage.getItem("userInfo")).projects[0].projectId}&category=${this.page}&title=${this.formInline.titleTxt}&oldTitle=${this.$parent.detailsData.title}&ts=${this.$parent.detailsData.ts}`,
                  this.param,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                      "X-Authorization": `Bearer ${tokenString}`,
                    },
                  }
                )
                .then((res) => {
                  if (res && res.status == 200) {
                    res.data.status == "EXISTED"
                      ? this.$message.success("修改成功,文件已存在!")
                      : this.$message.success("修改成功!");
                    this.$parent.dialogVisible = false;
                    setTimeout(() => {
                      this.$parent.getList();
                      this.$store.commit("SET_LOADING", false);
                    }, 1000);
                  }
                });
            }
          } else {
            this.$message.error("请添加文件！");
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeBtn() {
      this.$parent.dialogVisible = false;
    },

    handleRemove(file, fileList) {
      this.fileList = [];
      this.param = null;
    },
    handleExceed(files, fileList) {
      this.$message.warning("只能上传一个文件");
    },
    httpRequest(data) {
      this.param = null;
      this.param = new FormData();
      this.param.append("file", data.file);
      // console.log(this.param.get("file"));
    },
  },
  created() {
    if (this.title == "编辑") {
      this.formInline.titleTxt = this.$parent.detailsData.title;
      this.fileList = [
        {
          name: this.$parent.detailsData.title,
          url: this.$parent.detailsData.uri,
        },
      ];
      // this.param = new FormData();
      // this.param.append("file", this.$parent.detailsData.uri);
    }
  },
};
</script>

<style lang="scss" scoped>
.addEditDialog {
  .formContent {
    width: 70%;
    height: 550px;
    overflow-y: auto;
    .upLoadWrap {
      width: 40%;
    }
  }
}
</style>